import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Form from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import Section from '@/components/base/Section'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type NewsletterProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    title: string
    image: WPImage
    form: {
      title_variant: TypographyProps['variant']
      title_component: TypographyProps['component']
      title: string
      paragraph: string
      form_id: string
      submit: string
      fields: any[]
    }
  }>

const Newsletter = ({
  title,
  title_variant,
  title_component,
  image,
  form,
  className,
  ...props
}: NewsletterProps) => {
  return (
    <Section className={cn([className])} {...props}>
      <Container>
        <Grid className="gap-y-gutter">
          {title ? (
            <div className="col-span-4 md:col-span-6 lg:col-span-12">
              <Typography
                variant={title_variant}
                component={title_component}
                className="text-heading"
              >
                {title}
              </Typography>
            </div>
          ) : null}

          <div className="col-span-4 md:col-span-3 lg:col-span-6">
            <div className="aspect-h-[240] aspect-w-[350] h-full w-full rounded-[3rem] bg-dark-blue md:aspect-h-[467] md:aspect-w-[645]">
              <Image
                source={image}
                fill
                fit="cover"
                className="rounded-[3rem]"
              />
            </div>
          </div>
          <div className="col-span-4 md:col-span-3 lg:col-span-6">
            <div
              className={cn([
                'grid h-full grid-rows-[auto,_1fr] gap-y-gutter rounded-[3rem] bg-medium-blue',
                'px-[2rem] pb-[2rem] pt-[5rem] lg:px-[3rem] lg:pb-[3rem] lg:pt-[6rem] xl:px-[6rem]'
              ])}
            >
              <div className="grid gap-y-[1.5rem]">
                {form?.title ? (
                  <Typography
                    variant={form?.title_variant}
                    component={form?.title_component}
                    className="text-white"
                  >
                    {form?.title}
                  </Typography>
                ) : null}

                {form?.paragraph ? (
                  <Typography variant="body" className="text-white">
                    {form?.paragraph}
                  </Typography>
                ) : null}
              </div>

              <div>
                <Form
                  form_id={form?.form_id}
                  fields={form?.fields}
                  submit={form?.submit}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default Newsletter
